import { useContext } from 'react'
import { AppContext, type ContextInput, defaultValue } from './AppProvider.js'

/**
 * Main context for the whole app, only generics should be inside!
 */
export function useApp(): ContextInput {
  const context = useContext(AppContext)

  if (context === defaultValue) {
    throw new Error('not used within AppProvider.')
  }

  return context
}
